import { AuthorizedPaths } from '@bbkAdminRouter/router-paths';
import { matchPath } from '@bbkShared/react-router';

const baseAuthPath = '/company/:companyKey/app/:appKey';
const previewPaths = [
  `${baseAuthPath}${AuthorizedPaths.experiencesFunnelPreview}`,
  `${baseAuthPath}${AuthorizedPaths.experiencesHostedPreview}`,
  `${baseAuthPath}${AuthorizedPaths.experiencesFunnelPreviewFull}`,
  `${baseAuthPath}${AuthorizedPaths.experiencesHostedPreviewFull}`,
  `${baseAuthPath}${AuthorizedPaths.pricingTablePreview}`,
  `${baseAuthPath}${AuthorizedPaths.pricingTablePreviewFull}`,
];

const normalizePathname = (pathname: string) =>
  pathname !== '/' && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

export const isPreviewPage = (pathname: string): boolean => {
  const normalizedPathname = normalizePathname(pathname);

  return previewPaths.some((path) =>
    Boolean(matchPath(normalizedPathname, { path, exact: true }))
  );
};
